export const state = {
	url:'',
	login: false,
	intentos: 0,
	calificacion:0,
	answersSuccess:0,
	stepActive: 1,
	alertas:true,
	ejercicioActivo: 'ejercicio-1',
	tiendaSeleccionada: '',
	// tiendaSeleccionada: 'autoservicio',
	stepOne:{
		tipoSolicitud: 'Nueva Solicitud',
		tipoSolicitudAcuerdo: 'Volumen'
	},
	stepTwo:{
		pais:'México',
		organizacionCompras:'MX01-AUTOS Y SERVICIO',
		grupoCompras:'M11-Org. Compras MX',
		descripcionSolicitudAcuerdo:'Acuerdo de volumen',
		validoDesdeFecha:'',
		validoHastaFecha:'',
		tipoDeLocacion:'',
		autoRenovacion:false,
		metodoDePago:'Neteo',
		moneda:'Pesos mexicanos',
		calendarioDeLiquidacion:'',
		terminosDePago:'Z000',
		numeroSAP:'',
		pagadorSAP:''
	},
	stepThree:{
		tipoDeAportacion:'',
		descripcionAportacion:'',
		valdioDe:'',
		validezA:'',
		baseDeCalculo:'',
		tipoDeDevolucion:'',
		autoAgregarArticulos:true,
		baseArticulo:'',
		niveles:'',
		tipoDeTarifaNivel:'',
		tipoDeEscala:'',
		monedaUM:'MXN',
		region:'',
		formato:'',
		tipoDeDistribucion:'',
		jerarquias:{
			departamento:'',
			descripcionDepartamento:'',
			subclase:'',
			descripcionSubclase:'',
			fineline:'',
			descripcionFineline:'',
		},
		articulo:false,
		valorDesde:'0',
		valorHasta:'99,999,999,999',
		tarifa:''
	},
	stepFour:{
		comprador:{
			userid:'',
			nombre:'',
			apellido:''
		},
		dmm:{
			userid:'',
			nombre:'',
			apellido:''
		},
		idProveedorRetailLink:'',
		capturarProveedor:true,
		nombreContactoProveedor:'',
		correoContactoProveedor:'',
		telefonoContactoProveedor:'',
		faxContactoProveedor:'',
		identificacionDelContactoDelProveedor:''
	},
	stepFive:{
		visibilidad: 'Visible al proveedor',
		documents:[],
		imprimir:false,
		comentarios:[]
	},
	dataEjercicio1:{
		stepOne:{
			tipoSolicitud: 'Nueva Solicitud',
			tipoSolicitudAcuerdo: 'Volumen'
		},
		stepTwo:{
			pais:'México',
			organizacionCompras:'MX01-AUTOS Y SERVICIO',
			grupoCompras:'M11-Org. Compras MX',
			descripcionSolicitudAcuerdo:'Acuerdo de volumen',
			validoDesdeFecha:'2019-07-01',
			validoHastaFecha:'2019-12-31',
			tipoDeLocacion:'100001',
			autoRenovacion:true,
			numeroSAP:'Multiples valores seleccionados',
			pagadorSAP:'1000022565'
		},
		stepThree:{
			tipoDeAportacion:513,
			valdioDe:'2019-01-01',
			validezA:'2019-12-31',
			baseDeCalculo:'Recepcion',
			baseArticulo:'Grupo Artículos',
			niveles:'Monto',
			tipoDeTarifaNivel:'Porcentual',
			tipoDeEscala:'Escalonado',
			valorDesde:'0',
			valorHasta:'99,999,999,999',
			tarifa:'2.5',
			formato:
			[
			{"tipoubicacion":10001,"banner":100351,"descripcion":"SUPERAMA"},
			{"tipoubicacion":10001,"banner":100301,"descripcion":"WM SUPERCENTER"},
			{"tipoubicacion":10001,"banner":100451,"descripcion":"BODEGA"},
			{"tipoubicacion":10013,"banner":101051,"descripcion":"DISTRIBUTION"}
			],
			tipoDeDistribucion:'Todas las tiendas',
			jerarquias:{
				departamento:'90',
				fineline:'1301',
			},
		},
		stepFour:{
			comprador:{userid:'A0F00TH'},
			dmm:{userid:'A0N00PC'},
			idProveedorRetailLink:'76TV7ED'
		}
	},
	dataEjercicio2:{
		stepOne:{
			tipoSolicitud: 'Nueva Solicitud',
			tipoSolicitudAcuerdo: 'Volumen'
		},
		stepTwo:{
			pais:'México',
			organizacionCompras:'MX01-AUTOS Y SERVICIO',
			grupoCompras:'M11-Org. Compras MX',
			descripcionSolicitudAcuerdo:'Acuerdo de volumen',
			validoDesdeFecha:'2019-07-01',
			validoHastaFecha:'2019-10-30',
			tipoDeLocacion:'100017',
			autoRenovacion:true,
			numeroSAP:'1000047614',
			pagadorSAP:'1000047614'
		},
		stepThree:{
			tipoDeAportacion:527,
			valdioDe:'2019-03-01',
			validezA:'2019-04-15',
			baseDeCalculo:'POS',
			baseArticulo:'Grupo Artículos',
			niveles:'Cantidad',
			tipoDeTarifaNivel:'Monto por Cantidad',
			tipoDeEscala:'Escalonado',
			valorDesde:'0',
			valorHasta:'99,999,999,999',
			tarifa:'431.03',
			formato:
			[
			{tipoubicacion: 1000017,banner:100551 ,descripcion:'SAM´S CLUB'},
			{tipoubicacion: 1000019,banner:101051 ,descripcion:'DISTRIBUTION'}
			],
			tipoDeDistribucion:'Todas las tiendas',
			jerarquias:{
				departamento:'94',
				subclase:'004'
			},
			articulo:{
				upc:'41003332002',
				win:'634391',
				descripcion:'VENTILAD 56" INDUSTR',
				indicador:'F',
				unidad:'EA'
			}
		},
		stepFour:{
			comprador:{userid:'A0F00TH'},
			dmm:{userid:'A0N00PC'},
			idProveedorRetailLink:'4MM1H2H'
		},
	},
	dataEmpty: {
		stepOne:{
			tipoSolicitud: 'Nueva Solicitud',
			tipoSolicitudAcuerdo: 'Volumen'
		},
		stepTwo:{
			pais:'México',
			organizacionCompras:'MX01-AUTOS Y SERVICIO',
			grupoCompras:'M11-Org. Compras MX',
			descripcionSolicitudAcuerdo:'Acuerdo de volumen',
			validoDesdeFecha:'',
			validoHastaFecha:'',
			tipoDeLocacion:'',
			autoRenovacion:false,
			metodoDePago:'Neteo',
			moneda:'Pesos mexicanos',
			calendarioDeLiquidacion:'',
			terminosDePago:'Z000',
			numeroSAP:'',
			pagadorSAP:''
		},
		stepThree:{
			tipoDeAportacion:'',
			descripcionAportacion:'',
			valdioDe:'',
			validezA:'',
			baseDeCalculo:'',
			tipoDeDevolucion:'',
			autoAgregarArticulos:true,
			baseArticulo:'',
			niveles:'',
			tipoDeTarifaNivel:'',
			tipoDeEscala:'',
			monedaUM:'',
			region:'',
			formato:'',
			tipoDeDistribucion:'',
			jerarquias:{
				departamento:'',
				descripcionDepartamento:'',
				subclase:'',
				descripcionSubclase:'',
				fineline:'',
				descripcionFineline:'',
			},
			articulo:false,
			valorDesde:'0',
			valorHasta:'99,999,999,999',
			tarifa:''
		},
		stepFour:{
			comprador:{
				userid:'',
				nombre:'',
				apellido:''
			},
			dmm:{
				userid:'',
				nombre:'',
				apellido:''
			},
			idProveedorRetailLink:'',
			capturarProveedor:true,
			nombreContactoProveedor:'',
			correoContactoProveedor:'',
			telefonoContactoProveedor:'',
			faxContactoProveedor:'',
			identificacionDelContactoDelProveedor:''
		},
		stepFive:{
			visibilidad: 'Visible al proveedor',
			documents:[],
			imprimir:false,
			comentarios:[]
		}
	}
}